import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Work from '../views/Work.vue'
import Login from '../views/Login.vue'
import staff from '../views/staff.vue'
import home from '../views/home.vue'
import test from '../views/test.vue'
import lighttest from '../views/lighttest.vue';
import shubin from '../views/GangJin.vue';
import store from '../store/store'
import { Message } from 'element-ui'

import MeiLiXiangCun from '@/views/MeiLiXiangCun/173.vue'
import MainMap from '@/views/MeiLiXiangCun/MainMap.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/HomeView',
    name: 'HomeView',
    component: HomeView,
    children: [
      {

        path: '/staff',name: 'staff',
        component: (resolve) => require(['@/views/staff'], resolve),
      },
      {
        path: '/Work',name: 'Work',
        component: (resolve) => require(['@/views/Work'], resolve),
      },
      {      
        path: '/home',name: 'home',
        component: (resolve) => require(['@/views/home'], resolve),
      },
      {      
        path: '/lighttest/:id',name: 'lighttest',props:true,
        component: lighttest,
      },
      {      
        path: '/lighttest',name: 'lighttest',
        component: (resolve) => require(['@/views/lighttest'], resolve),
      },
      {      
        path: '/Bi',name: 'Bi',
        component: (resolve) => require(['@/views/Bi'], resolve),
      },
      {      
        path: '/LiZiQiang',name: 'LiZiQiang',
        component: (resolve) => require(['@/views/LiZiQiang.vue'], resolve),
      },
      {      
        path: '/ProcessModel',name: 'ProcessModel',
        component: (resolve) => require(['@/views/ProcessModel'], resolve),
      },
      {      
        path: '/test',name: 'test',
        component: (resolve) => require(['@/views/test'], resolve),
      },
      
      {      
        path: '/ZiYuan/RuanJian',name: 'RuanJian',
        component: (resolve) => require(['@/views/ZiYuan/RuanJian.vue'], resolve),
      },

      // {      
      //   path: '/GangJin',name: 'GangJin',
      //   component: (resolve) => require(['@/views/GangJin'], resolve),
      //   children: [
      //     {      
      //       path: '/GangJin/GangJinGuanLi',name: 'GangJinGuanLi',
      //       component: (resolve) => require(['@/views/GangJin/GangJinGuanLi.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/GangJinPanDian',name: 'GangJinPanDian',
      //       component: (resolve) => require(['@/views/GangJin/GangJinPanDian.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/GangJinTaiZhang',name: 'GangJinTaiZhang',
      //       component: (resolve) => require(['@/views/GangJin/GangJinTaiZhang.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/QuYuHuaFen',name: 'QuYuHuaFen',
      //       component: (resolve) => require(['@/views/GangJin/QuYuHuaFen.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/XianChangWenTi',name: 'XianChangWenTi',
      //       component: (resolve) => require(['@/views/GangJin/XianChangWenTi.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/ZhiShiKu',name: 'ZhiShiKu',
      //       component: (resolve) => require(['@/views/GangJin/ZhiShiKu.vue'], resolve),
      //     },
      //     {      
      //       path: '/GangJin/GangJinJinDu',name: 'GangJinJinDu',
      //       component: (resolve) => require(['@/views/GangJin/GangJinJinDu.vue'], resolve),
      //     },
          

      //   ]
      // },
      
    ],
    
  },
  {
    path: '/',
    name: 'login',
    component: Login,
  },
  {
    path: '/BimAutoCreatePlantFloor',name: 'BimAutoCreatePlantFloor',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/Main.vue'], resolve), 
  },
  {
    path: '/BimAutoCreatePlantFloor/ai',name: 'BimAutoCreatePlantFloorAi',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/Ai.vue'], resolve), 
  },
  {
    path: '/BimAutoCreatePlantFloor/BiData',name: 'BimAutoCreatePlantFloorBiData',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/BiData.vue'], resolve), 
  },
  {
    path: '/BimAutoCreatePlantFloor/BiDataTwo',name: 'BimAutoCreatePlantFloorBiDataTwo',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/BiDataTwo.vue'], resolve), 
  },
  {
    path: '/BimAutoCreatePlantFloor/BiDataThree',name: 'BimAutoCreatePlantFloorBiDataThree',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/BiDataThree.vue'], resolve), 
  },
  {
    path: '/BimAutoCreatePlantFloor/BiShow1',name: 'BiShow1',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/BiShow1.vue'], resolve), 
  },
  {
    path: '/BimAutoCreatePlantFloor/BiShow2',name: 'BiShow2',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/BiShow2.vue'], resolve), 
  },
  {
    path: '/BimAutoCreatePlantFloor/BiShow3',name: 'BiShow3',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/BiShow3.vue'], resolve), 
  },
  {
    path: '/BimAutoCreatePlantFloor/ZiYuan',name: 'ZiYuan',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/ZiYuan.vue'], resolve), 
  },
  {
    path: '/BimAutoCreatePlantFloor/BiZiChan',name: 'BiZiChan',
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/BiZiChan.vue'], resolve), 
  },
  {      
    path: '/GangJin',name: 'GangJin',
    component: (resolve) => require(['@/views/GangJin'], resolve),
    children: [
      {      
        path: '/GangJin/GangJinGuanLi',name: 'GangJinGuanLi',
        component: (resolve) => require(['@/views/GangJin/GangJinGuanLi.vue'], resolve),
      },
      {      
        path: '/GangJin/GangJinPanDian',name: 'GangJinPanDian',
        component: (resolve) => require(['@/views/GangJin/GangJinPanDian.vue'], resolve),
      },
      {      
        path: '/GangJin/GangJinTaiZhang',name: 'GangJinTaiZhang',
        component: (resolve) => require(['@/views/GangJin/GangJinTaiZhang.vue'], resolve),
      },
      {      
        path: '/GangJin/QuYuHuaFen',name: 'QuYuHuaFen',
        component: (resolve) => require(['@/views/GangJin/QuYuHuaFen.vue'], resolve),
      },
      {      
        path: '/GangJin/XianChangWenTi',name: 'XianChangWenTi',
        component: (resolve) => require(['@/views/GangJin/XianChangWenTi.vue'], resolve),
      },
      {      
        path: '/GangJin/ZhiShiKu',name: 'ZhiShiKu',
        component: (resolve) => require(['@/views/GangJin/ZhiShiKu.vue'], resolve),
      },
      {      
        path: '/GangJin/GangJinJinDu',name: 'GangJinJinDu',
        component: (resolve) => require(['@/views/GangJin/GangJinJinDu.vue'], resolve),
      },
      

    ]
  },
  
  {      
    path: '/BimAutoCreatePlantFloor/:id',name: 'BimAutoCreatePlantFloor',props:true,
    component: (resolve) => require(['@/views/BimAutoCreatePlantFloor/Main.vue'], resolve),
  },
  {      
    path: '/LightModelCore',name: 'LightModelCore',
    component: (resolve) => require(['@/views/LightModelCore/LightMain.vue'], resolve), 
  },
  {      
    path: '/BiModel',name: 'BiMain',
    component: (resolve) => require(['@/views/BiModel/BiMain.vue'], resolve),
  },
  {      
    path: '/Phone',name: 'Phone',
    component: (resolve) => require(['@/views/Phone/Main.vue'], resolve),
  },
  {      
    path: '/WaterMain',name: 'WaterMain',
    component: (resolve) => require(['@/views/Water/WaterMain.vue'], resolve),
  },
  {      
    path: '/ShiPingLiuTest',name: 'ShiPingLiuTest',
    component: (resolve) => require(['@/views/ShiPingLiuTest.vue'], resolve),
  },
  {
    path: '/HXXiangGuan',name: 'HXXiangGuan',
    component: (resolve) => require(['@/views/HXXiangGuan/Main.vue'], resolve),
    
    children: [
      {
        path: 'NewPage',name: 'NewPage',
        component: (resolve) => require(['@/views/HXXiangGuan/NewPage.vue'], resolve),
        meta: {
          requirePermission: 'home:view'
        }
      },
      {
        path: 'MainWindow',name: 'MainWindow',
        component: (resolve) => require(['@/views/HXXiangGuan/MainWindow.vue'], resolve),
        meta: {
          requirePermission: 'summary:view'
        }
      },
      {
        path: 'ProjectList',name: 'ProjectList',
        component: (resolve) => require(['@/views/HXXiangGuan/ProjectList.vue'], resolve),
        meta: { 
          requirePermission: 'project:view'
        }
      }
    ]
  },
  {
    path: '/HXXiangGuan/Logo',name: 'HXXiangGuanLogo',
    component: (resolve) => require(['@/views/HXXiangGuan/Logo.vue'], resolve),
  },
  {
    path: '/ProjectDetail',name: 'ProjectDetail',
    component: (resolve) => require(['@/views/HXXiangGuan/ProjectDetail.vue'], resolve),
    meta: {
      requirePermission: 'project:view'
    }
  },
  {
    path: '/HuaNanZongBu/Main',name: 'HuaNanZongBu',
    component: (resolve) => require(['@/views/HuaNanZongBu/Main.vue'], resolve),
  },
  {
    path: '/MeiLiXiangCun/Main',name: 'MeiLiXiangCun',
    component: (resolve) => require(['@/views/MeiLiXiangCun/Main.vue'], resolve),
  },
  {
    path: '/MeiLiXiangCun/173',name: 'MeiLiXiangCun173',
    component: (resolve) => require(['@/views/MeiLiXiangCun/173.vue'], resolve),
  },
  {
    path: '/MeiLiXiangCun/MainMap',name: 'MeiLiXiangCunMainMap',
    component: (resolve) => require(['@/views/MeiLiXiangCun/MainMap.vue'], resolve),
  }, 
  {
    path: '/MeiLiXiangCun/:suffix',
    name: 'MeiLiXiangCun',
    component: MeiLiXiangCun,
    props: true  // 将 suffix 参数传递给组件
  },
  ,
  {
    path: '/XieTongPingTai/lightModel/Main/:fileid',
    name: 'lightModelMain',
    component: (resolve) => require(['@/views/XieTongPingTai/lightModel/Main.vue'], resolve),
    props: true  // 将 fileid 参数传递给组件
  },
  {
    path: '/XieTongPingTai',
    name: 'XieTongPingTai',
    component: (resolve) => require(['@/views/XieTongPingTai/Layout..vue'], resolve),
    children: [
      // 用户管理 - 侧边栏分项
      {
        path: 'user/UserManage',
        name: 'UserManage',
        component: (resolve) => require(['@/views/XieTongPingTai/user/UserManage.vue'], resolve),
        meta: {
          title: '用户管理'
        }
      },
      // 项目管理 - 侧边栏分项
      {
        path: 'project/ProjectList',
        name: 'ProjectList',
        component: (resolve) => require(['@/views/XieTongPingTai/project/ProjectList.vue'], resolve),
        meta: {
          title: '项目列表'
        }
      },
      // 项目模型列表 - 二级页面
      {
        path: 'project/ProjectModels/:id',
        name: 'ProjectModels',
        component: (resolve) => require(['@/views/XieTongPingTai/project/ProjectModels.vue'], resolve),
        meta: {
          title: 'BIM模型列表'
        },
        props: true // 将 hubid 参数传递给组件
      },
      {
        path: 'data-statistics/DataStatistics',
        name: 'DataStatistics',
        component: () => import('@/views/XieTongPingTai/data-statistics/DataStatistics.vue')
      },
      {
        path: 'digital-mall/DigitalMall',
        name: 'DigitalMall',
        component: () => import('@/views/XieTongPingTai/digital-mall/DigitalMall.vue')
      }
    ]
  },
]



const router = new VueRouter({
  routes
})

// router.beforeEach((to, from, next) => {
//   const userInfo = store.state.userinfo;
//   // 未登录用户重定向到登录页
//   if (!userInfo.username && to.path !== '/HXXiangGuan/' && !to.path.startsWith('/HXXiangGuan/Logo')) {
//     next('/HXXiangGuan/Logo');
//     return;
//   }
//   // 验证路由权限
//   if (to.meta.requirePermission) {
//     if (userInfo.role === 'admin' || userInfo.permissions.includes(to.meta.requirePermission)) {
//       next();
//     } else {
//       next('/HXXiangGuan/MainWindow');
//       Message.warning('无权限访问此页面');
//     }
//   } else {
//     next();
//   }
//   if (!userInfo.username && to.path !== '/' && !to.path.startsWith('/HXXiangGuan/Logo')) {
//     next('/HXXiangGuan/Logo');
//     return;
//   }
//   // 验证路由权限
//   if (to.meta.requirePermission) {
//     if (userInfo.role === 'admin' || userInfo.permissions.includes(to.meta.requirePermission)) {
//       next();
//     } else {
//       next('/HXXiangGuan');
//       Message.warning('无权限访问此页面');
//     }
//   } else {
//     next();
//   }});
export default router